<template>
  <div class="mediumWrapper">
    <div class="channelSelection">
      <InputFloatLabel :disabled="mediumTypeDisabled"
                       class="setupInfos" icon-size="2.4em" :value="deviceTypeName" label="Mediumbezeichnung"
                       :icon="deviceMapping[deviceType]['icon']" iconColor="#D70465" @click="toggleDevice"
                       @input="deviceInput">
      </InputFloatLabel>
      <XXLCheckbox @change="checkboxChange(getId('roc'))" class="setupInfos" :id="getId('roc')"
                   labelDetail="Platzierung" label="Run of Channel"
                   :initial="this.isFilled(this.runOfChannelOrders)"></XXLCheckbox>
      <XXLCheckbox @change="checkboxChange(getId('ros'))" class="setupInfos" :id="getId('ros')"
                   labelDetail="Platzierung" label="Run of Site"
                   :initial="this.isFilled(this.runOfSiteOrders)"></XXLCheckbox>
      <XXLCheckbox @change="checkboxChange(getId('fp'))" class="setupInfos" :id="getId('fb')"
                   labelDetail="Platzierung" label="Festplatzierung"
                   :initial="this.isFilled(this.fpOrders)"></XXLCheckbox>
    </div>
    <AccordionSection :key="this.keyRoc" v-if="channelIsSelected('roc')" title="Run of Channel">
      <InsertionOrder v-for="(order) in runOfChannelOrders" :key="'roc-'+order.index" :mediumIndex="index"
                      :index="order.index" :type="order.type"></InsertionOrder>
    </AccordionSection>
    <AccordionSection v-if="channelIsSelected('ros')" title="Run of Site">
      <InsertionOrder v-for="(order) in runOfSiteOrders"
                      :key="'ros-'+order.index" :mediumIndex="index"
                      :index="order.index" :sites-only=true :type="order.type"></InsertionOrder>
    </AccordionSection>
    <AccordionSection v-if="channelIsSelected('fp')" title="Festplatzierung">
      <InsertionOrder v-for="(order) in fpOrders" :key="'fp-'+order.index"
                      :mediumIndex="index"
                      :index="order.index" :sites-only=true :type="order.type"></InsertionOrder>
    </AccordionSection>
  </div>
</template>

<script>
import XXLCheckbox from "../../../components/inputs/XXLCheckbox";
import AccordionSection from "../AccordionSection";
import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
import InsertionOrder from "./InsertionOrder";

export default {
  name: "Medium",
  components: {InsertionOrder, InputFloatLabel, AccordionSection, XXLCheckbox},
  props: {
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      types: [],
      type: this.$attrs.type,
      channels: [],
      keyRoc: "123rocasjdkals",
      name: this.$attrs.name ? this.$attrs.name : '',
      deviceType: this.$attrs.type,
      deviceMapping: {
        'Desktop': {
          'icon': 'icon-device-desktop'
        },
        'Online': {
          'icon': 'icon-device-xdigital'
        },
        'Mobile': {
          'icon': 'icon-device-mobile'
        },
        'Tablet': {
          'icon': 'icon-device-tablet'
        }
      }
    };
  },
  computed: {
    deviceTypeName() {
      return this.deviceType + ' ' + this.name;
    },
    vuexState() {
      return this.$store.state;
    },
    insertionOrders() {
      return this.$store.getters['campaign/insertionOrdersSorted'](this.index);
    },
    runOfChannelOrders() {
      return this.insertionOrders['roc'];
    },
    runOfSiteOrders() {
      return this.insertionOrders['ros'];
    },
    fpOrders() {
      return this.insertionOrders['fp'];
    },
    mediumTypeDisabled() {
      return this.$attrs.id !== null;
    }
  },
  methods: {
    channelIsSelected: function (channel) {
      return this.channels.indexOf(this.getId(channel)) !== -1;
    },
    getId(channel) {
      return channel + this.index;
    },
    checkboxChange: function (id) {
      if (this.channels.indexOf(id) !== -1) {
        this.deleteInsertionOrders(id);
        this.channels.splice(this.channels.indexOf(id), 1);
      } else {
        this.channels.push(id);
      }

    },
    toggleDevice: function () {
      if (!this.mediumTypeDisabled) {
        switch (this.deviceType.toLowerCase()) {
          case 'desktop':
            this.deviceType = 'Online';
            break;
          case 'online':
            this.deviceType = 'Tablet';
            break;
          case 'tablet':
            this.deviceType = 'Mobile';
            break;
          case 'mobile':
            this.deviceType = 'Desktop';
            break;
        }
        this.$store.commit('campaign/deviceTypeChange', {'index': this.index, 'type': this.deviceType});
      }

    },
    deviceInput: function (value) {
      if (value === this.deviceType) {
        this.name = ' ';
      } else {
        this.name = value.replace(this.deviceType + ' ', '');
      }
      this.$store.commit('campaign/changeMediumName', {'index': this.index, 'name': this.name})
    },
    isFilled(values) {
      values = values[0];
      return !(values.line_items.length === 0);
    }
    ,
    deleteInsertionOrders(id) {
      console.log(id);
      let orders = id.indexOf('fp') !== '-1' ? this.fpOrders : (id.indexOf('roc') !== '-1' ? this.runOfChannelOrders : this.runOfSiteOrders);
      console.log('orders: '+ JSON.stringify(orders));
      for (let i = 0; i < orders.length; i++) {
        console.log('index1 '+this.index);
        console.log('index2 '+orders[i].index);
        this.$store.commit('campaign/deleteInsertionOrder', {
          'mediumIndex': this.index,
          'index': orders[i].index
        });
      }
    }
  },
  mounted() {
    if (this.isFilled(this.runOfChannelOrders)) {
      this.checkboxChange(this.getId('roc'));
    }
    if (this.isFilled(this.runOfSiteOrders)) {
      this.checkboxChange(this.getId('ros'));
    }
    if (this.isFilled(this.fpOrders)) {
      this.checkboxChange(this.getId('fp'));
    }
  }
}
</script>

<style lang="scss" scoped>
.channelSelection {
  padding: 1.5rem;
}

.setupInfos {
  display: inline-block;
  width: 23.5%;
  margin-right: 2%;
}

.setupInfos:last-child {
  margin-right: 0%;
}

.insertionOrderWrapper {
  margin-bottom: 1.5rem;
  margin-top: 1rem;
}

.insertionOrderOuterWrapper {
  border-bottom: 1px solid $grey;
  padding-bottom: 1.5rem;
  margin-top: 1rem;
}

.insertionOrderOuterWrapper:last-child {
  border-bottom: none !important;
}

[class~='insertionOrderWrapper']:last-of-type {
  margin-bottom: 0;
}


</style>